import { Box, Button, TextField, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {  Stack} from "@mui/material";
import {
   DownloadOutlined,
   SpeakerNotesOutlined,
} from "@mui/icons-material";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { DownloadFile } from "./quotaSlice";

export default function Comments() {
   const dispatch = useDispatch();
   const state = useSelector((store) => store.quota);

   const {
      quotaForApprovalTable, quotaCustomerBreakdown
   } = state;  
   if (quotaCustomerBreakdown === null) {
      return null;
   }
   const handleDownloadFile = (filepath) =>{
      dispatch(DownloadFile(filepath));
   }

   const {comments, listQuotaFiles} = quotaCustomerBreakdown
   return (
      quotaForApprovalTable && (
      <Box sx={{ mt: 2 }}>
         {listQuotaFiles?.length > 0 && (
                  <Stack direction="row" alignItems="center" gap={2}>
                     <Typography sx={{ color: "#007DC3", fontWeight: "bold", width: "100%"}}>
                     <AttachFileIcon  color="info" />
                        Attachments
                     </Typography>
                  </Stack>
               )}
               <Table>
                  <TableBody>
                     {listQuotaFiles?.map((row) => {
                        return (
                           <TableRow className="tableRow" key={row?._id}>
                              <TableCell
                                 className="tableCell"
                                 sx={{ flexGrow: 1 }}
                              >
                                 {row.filePath}
                              </TableCell>
                              <TableCell className="tableCell">
                                 <Button
                                    variant="outlined"
                                    startIcon={<DownloadOutlined />}
                                    size="small"
                                    onClick={() => handleDownloadFile(row.filePath)}
                                 >
                                    Download
                                 </Button>{" "}
                              </TableCell>
                           </TableRow>
                        );
                     })}
                  </TableBody>
               </Table>
         <div>
            <Stack direction="row" alignItems="center" gap={2} sx={{mt:3, mb: 1}}>
               
                  <Typography sx={{ color: "#007DC3", fontWeight: "bold", width: "100%" }}>
                  <SpeakerNotesOutlined sx={{transform:" translate(0px, 6px)",width: "20px", mr: 1,}} color="info" />
                     Comments
               </Typography>
            </Stack>
         </div>

         <div>
            <TextField className={'fullWidth'}
               size="large"
               multiline
               rows={6}
               style={{overflowY:'auto'}}
               value ={comments}
               disabled
               //inputProps={{ style: { width: 400 } }}
            />
         </div>
         {/* <div>
            <Button
               sx={{
                  width: 40,
                  bgcolor: "blue.main",
                  color: "white.main",
                  textTransform: "none",
                  fontWeight: "bold",
                  mt: 1,
                  "&:hover": {
                     bgcolor: "skyBlue.main",
                     color: "black.main",
                  },
               }}
            >
               View
            </Button>
         </div> */}
      </Box>
      )
   );
}
